/* eslint-disable */

<template>
  <div>

    <vue-sortable :options="options" @drag:start="startedDrag" @drag:stop="stoppedDrag" @sortable:sort="sort">
      <div class="vx-row " :class="{'cursor-drag' : draggingCard === true}">
        <div class="vx-col lg:w-3/12 md:w-3/12 sm:w-5/5">
          <vx-card class="mb-base">
            <h3 class="font-bold mb-4">Controls</h3>
            <vue-draggable-container id="wordBank" class="wordBank">
              <h5 class="dragBlock  my-2 font-semibold cursor-pointer ">Recon</h5>
              <h5 class="dragBlock my-2 font-semibold cursor-pointer ">Weaponization</h5>
              <h5 class=" dragBlock my-2 font-semibold cursor-pointer ">Delivery</h5>
              <h5 class="dragBlock my-2 font-semibold cursor-pointer ">Exploitation</h5>
              <h5 class=" dragBlock my-2 font-semibold cursor-pointer ">Installation</h5>
              <h5 class=" dragBlock my-2 font-semibold cursor-pointer ">Command & Control</h5>
              <h5 class=" dragBlock my-2 font-semibold cursor-pointer ">Exfiltration</h5>
            </vue-draggable-container>
          </vx-card>
        </div>
        <div class="vx-col lg:w-9/12 md:w-9/12 sm:w-5/5">
          <vx-card class="mb-base">
            <div class="p-8">
              <div class="grid grid-cols-3 mb-20 gap-5">
                <div class="flex flex-col justify-between items-center rounded-lg p-4 bg-primary">
                  <h1 class="font-bold">2</h1>
                  <img src="https://cdn.discordapp.com/attachments/746242308084858900/937441746747547698/antivirus.png" class="w-2/5" style="max-width: 105px">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg w-full" id="input1"/>
                </div>
                <div class="flex flex-col justify-between items-center rounded-lg p-4 bg-primary">
                  <h1 class="font-bold">4</h1>
                  <img src="https://cdn.discordapp.com/attachments/746242308084858900/937442155578933258/spyware.png" class="w-2/5" style="max-width: 105px">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg mt-4 w-full" id="input3"/>
                </div>
                <div class="flex flex-col justify-between items-center rounded-lg p-4 bg-primary">
                  <h1 class="font-bold mb-2">6</h1>
                  <img src="https://cdn.discordapp.com/attachments/746242308084858900/937442377201762334/megaphone.png" class="w-2/5" style="max-width: 105px">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg mt-4 w-full" id="input5"/>
                </div>
              </div>
              <div class="grid grid-cols-4 gap-5">
                <div class="flex flex-col justify-between items-center rounded-lg p-4 bg-primary">
                  <h1 class="font-bold mb-2">1</h1>
                  <img src="https://cdn.discordapp.com/attachments/746242308084858900/937441639037825055/radar.png" class="w-2/5" style="max-width: 105px">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg mt-4 w-full" id="input0"/>
                </div>
                <div class="flex flex-col justify-between items-center rounded-lg p-4 bg-primary">
                  <h1 class="font-bold mb-2">3</h1>
                  <img src="https://cdn.discordapp.com/attachments/746242308084858900/937441832546222120/package.png" class="w-2/5" style="max-width: 105px">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg mt-4 w-full" id="input2"/>
                </div>
                <div class="flex flex-col justify-between items-center rounded-lg p-4 bg-primary">
                  <h1 class="font-bold mb-2">5</h1>
                  <img src="https://cdn.discordapp.com/attachments/746242308084858900/937442266279198851/box.png" class="w-2/5" style="max-width: 105px">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg mt-4 w-full" id="input4"/>
                </div>
                <div class="flex flex-col justify-between items-center rounded-lg p-4 bg-primary">
                  <h1 class="font-bold mb-2">7</h1>
                  <img src="https://cdn.discordapp.com/attachments/746242308084858900/937442433564831774/target.png" class="w-2/5" style="max-width: 105px">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg mt-4 w-full" id="input6"/>
                </div>
              </div>
            </div>
          </vx-card>
        </div>
      </div>
    </vue-sortable>
  </div>
</template>

<script>

import draggable from 'vuedraggable'
import Prism from 'vue-prism-component'

export default {
  data () {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
      draggingCard: false,
      //last_drag_error: false,

      options: {
        draggable: '.dragBlock',
        dropzone: '.dropzoneStandard'

      }
    }
  },
  methods: {
    startedDrag (x) {
      x.data.source.className += ' currently-dragging-standard'
      this.draggingCard = true
    },
    stoppedDrag () {
      this.draggingCard = false
    },
    sort (x) {
      const overContainer = x.data.dragEvent.data.overContainer
      const sourceContainer = x.data.dragEvent.data.sourceContainer
      if (overContainer && overContainer.id !== 'wordBank' && overContainer.children) {
        if (overContainer.children.length > 0 && overContainer.id !== sourceContainer.id) {
          x.cancel()
        }
      }
    },
    markSimulation () {

      let total_score = 0

      if (document.getElementById('input0').textContent === 'Recon') {
        document.getElementById('input0').style.borderColor = '#28C76F'
        document.getElementById('input0').style.backgroundColor = '#28C76F'
        total_score++
      } else {
        document.getElementById('input0').style.borderColor = '#fd4445'
        document.getElementById('input0').style.backgroundColor = '#fd4445'
      }

      if (document.getElementById('input1').textContent  === 'Weaponization') {
        document.getElementById('input1').style.borderColor = '#28C76F'
        document.getElementById('input1').style.backgroundColor = '#28C76F'
        total_score++
      } else {
        document.getElementById('input1').style.borderColor = '#fd4445'
        document.getElementById('input1').style.backgroundColor = '#fd4445'
      }

      if (document.getElementById('input2').textContent  === 'Delivery') {
        document.getElementById('input2').style.borderColor = '#28C76F'
        document.getElementById('input2').style.backgroundColor = '#28C76F'
        total_score++
      } else {
        document.getElementById('input2').style.borderColor = '#fd4445'
        document.getElementById('input2').style.backgroundColor = '#fd4445'
      }

      if (document.getElementById('input3').textContent  === 'Exploitation') {
        document.getElementById('input3').style.borderColor = '#28C76F'
        document.getElementById('input3').style.backgroundColor = '#28C76F'
        total_score++
      } else {
        document.getElementById('input3').style.borderColor = '#fd4445'
        document.getElementById('input3').style.backgroundColor = '#fd4445'
      }

      if (document.getElementById('input4').textContent  === 'Installation') {
        document.getElementById('input4').style.borderColor = '#28C76F'
        document.getElementById('input4').style.backgroundColor = '#28C76F'
        total_score++
      } else {
        document.getElementById('input4').style.borderColor = '#fd4445'
        document.getElementById('input4').style.backgroundColor = '#fd4445'
      }

      if (document.getElementById('input5').textContent  === 'Command & Control') {
        document.getElementById('input5').style.borderColor = '#28C76F'
        document.getElementById('input5').style.backgroundColor = '#28C76F'
        total_score++
      } else {
        document.getElementById('input5').style.borderColor = '#fd4445'
        document.getElementById('input5').style.backgroundColor = '#fd4445'
      }

      if (document.getElementById('input6').textContent  === 'Exfiltration') {
        document.getElementById('input6').style.borderColor = '#28C76F'
        document.getElementById('input6').style.backgroundColor = '#28C76F'
        total_score++
      } else {
        document.getElementById('input6').style.borderColor = '#fd4445'
        document.getElementById('input6').style.backgroundColor = '#fd4445'
      }

      if (total_score === this.dataLocal.legacy.total_score) {
        return this.$emit('simulation_full_correct', total_score)
      }

      this.$emit('simulation_getting_there', total_score)

    }

  },
  components: {
    draggable,
    Prism
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  }

}
</script>

